import React, { useState, useEffect, useMemo } from "react";
import { Segment, Message, } from "semantic-ui-react";
import { useParams, Redirect, } from "react-router-dom";

import { ServiceContext } from "../../store";
import { TResult, TLoadable, createUnloaded, isUnloaded, isLoaded, createLoaded, createLoadErrored, isLoadErrored } from "../../../sg-core";
import { useLoginStatus } from "../auth/store/authSelectors";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { PageTemplate } from "../components/PageTemplate/PageTemplate";
import { getRouteHrefById } from "../../../routing";
import { HavainnotRouteId } from "../../routes";


const getTextProps = (t: TFunction) => ({
    loadErrorText: t("Havainnon avaaminen epäonnistui")
});


interface IOpenObservationPage extends ReturnType<typeof getTextProps> { }

const OpenObservationPage: React.FC<IOpenObservationPage> = ({ loadErrorText }) => {
    const loginStatus = useLoginStatus();
    const { packageId } = useParams<{ packageId: string }>();

    const [observationId, setObservationId] = useState<TLoadable<number>>(createUnloaded());

    useEffect(() => {

        const getObservationId = async () => {
            const result: TResult<{ data: { observationId?: number } }> = await ServiceContext.common.getDataPackage(packageId);

            if (result.isSuccess && result.value.data.observationId) {
                setObservationId(createLoaded(result.value.data.observationId));
                return
            }
            setObservationId(createLoadErrored(new Error("err")));
        }

        if (isUnloaded(observationId) && isLoaded(loginStatus)) {
            getObservationId()
        }
    }, [observationId, packageId, loginStatus]);



    if (isLoaded(observationId) && isLoaded(loginStatus)) {
        return (
            <Redirect
                to={getRouteHrefById(HavainnotRouteId.ObservationPage, { observation: observationId.data })!}
            />
        )
    }


    if (isLoadErrored(observationId)) {
        return (<Message negative> {loadErrorText} </Message>);
    }

    return (
        <PageTemplate>
            <Segment placeholder loading basic />
        </PageTemplate>

    );

};

const MemoizedOpenObservationPage = React.memo(OpenObservationPage);

const ObservationPageContainer: React.FC = () => {
    const { t } = useTranslation();
    const textProps = useMemo(() => getTextProps(t), [t]);
    return <MemoizedOpenObservationPage {...textProps} />;
};

export default ObservationPageContainer;
